import React,{useEffect} from 'react'
import { useEyeconxStore }  from '../../store/eyeconxStore'
import { useNavigate } from 'react-router-dom'
function Logout() {
    const logout = useEyeconxStore(state=>state.logout)
    const navigate = useNavigate()
    useEffect(()=>{
        logout()
        navigate('/login')
    },[])
   
  return (
    <div>Logout</div>
  )
}

export default Logout